import axios from "axios";
import { Config } from "../../../Config/ApiConfig";

const API_KEY = Config().APIKEY;

export const isAuthenticated = async () => {
  const token = localStorage.getItem("token");

  if (!token) return false;

  try {
    const response = await axios.post(
      "https://polaris.polarcode.solutions/auth/renew_token",
      {},
      {
        headers: {
          "X-API-KEY": API_KEY,
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 200 && response.data.new_token) {
      localStorage.setItem("token", response.data.new_token); // Oppdater token
      return true;
    }
  } catch (err) {
    localStorage.removeItem("token"); // Fjern token hvis ugyldig
    return false;
  }

  return false;
};
